import React, { useState, useEffect } from 'react';
import { getMessageBydevice } from '../components/DbServices';
import Swal from 'sweetalert2';

export default function MessageLogModal({ device, onClose }) {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const res = await getMessageBydevice(device.id);
                setLogs(res.data || []);
            } catch (err) {
                console.error("Error fetching logs", err);
            } finally {
                setLoading(false);
            }
        };
        fetchLogs();
    }, [device.id]);

    return (
        <div className="custom-modal-backdrop" style={{ alignItems: 'center', backgroundColor: 'rgba(15, 23, 42, 0.7)' }}>
            <div className="custom-modal border-0 shadow-lg" style={{ maxWidth: '650px', width: '95%', borderRadius: '24px', overflow: 'hidden', padding: '0' }}>
                
                {/* Header with Vibrant Gradient */}
                <div className="p-4 text-white d-flex justify-content-between align-items-center bg-primary">
                    <div>
                        <h5 className="fw-bold mb-1">
                            <i className="bi bi-journal-text me-2"></i> Activity Logs
                        </h5>
                        <p className="mb-0 x-small opacity-75">Device: {device.device_name} • ID: {device.id}</p>
                    </div>
                    <button className="btn btn-link text-white p-0" onClick={onClose}>
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>

                <div className="p-4 bg-white">
                    {/* Log Stats Mini-bar */}
                    <div className="d-flex gap-3 mb-4">
                        <div className="flex-fill p-2 rounded-3 bg-success-subtle border border-success border-opacity-10 text-center">
                            <div className="text-success fw-bold small">{logs.filter(l => l.status === 'sent').length}</div>
                            <div className="text-success x-small fw-bold opacity-75">DELIVERED</div>
                        </div>
                        <div className="flex-fill p-2 rounded-3 bg-danger-subtle border border-danger border-opacity-10 text-center">
                            <div className="text-danger fw-bold small">{logs.filter(l => l.status !== 'sent').length}</div>
                            <div className="text-danger x-small fw-bold opacity-75">FAILED</div>
                        </div>
                        <div className="flex-fill p-2 rounded-3 bg-light border text-center">
                            <div className="text-dark fw-bold small">{logs.length}</div>
                            <div className="text-muted x-small fw-bold opacity-75">TOTAL</div>
                        </div>
                    </div>

                    <div className="log-scroll-area custom-scrollbar" style={{ maxHeight: '450px', overflowY: 'auto' }}>
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary border-2"></div>
                                <p className="text-muted small mt-2">Retrieving message history...</p>
                            </div>
                        ) : logs.length === 0 ? (
                            <div className="text-center py-5">
                                <i className="bi bi-chat-dots text-light display-1"></i>
                                <p className="text-muted mt-3">No message activity recorded yet.</p>
                            </div>
                        ) : (
                            <div className="d-flex flex-column gap-3 pe-2">
                                {logs.map((log) => {
                                    const isSent = log.status === 'sent';
                                    return (
                                        <div key={log.id} className="p-3 rounded-4 border-start border-4 transition-all log-item-hover" 
                                             style={{ 
                                                backgroundColor: '#f8fafc',
                                                borderLeftColor: isSent ? '#10b981' : '#ef4444'
                                             }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className={`rounded-circle bg-${isSent ? 'success' : 'danger'} p-1`} style={{ width: '8px', height: '8px' }}></div>
                                                    <span className="fw-bold text-dark small">To: {log.to_number}</span>
                                                </div>
                                                <span className="text-muted x-small fw-medium">
                                                    <i className="bi bi-clock me-1"></i>
                                                    {new Date(log.sent_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                </span>
                                            </div>
                                            
                                            <div className="bg-white p-2 rounded-3 border border-light-subtle mb-2">
                                                <p className="text-secondary x-small mb-0" style={{ lineHeight: '1.4' }}>{log.message}</p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-muted" style={{ fontSize: '10px' }}>
                                                    {new Date(log.sent_at).toLocaleDateString()}
                                                </span>
                                                <span className={`badge rounded-pill ${isSent ? 'bg-success' : 'bg-danger'} bg-opacity-10 text-${isSent ? 'success' : 'danger'}`} style={{ fontSize: '9px' }}>
                                                    {isSent ? 'DELIVERED SUCCESSFULLY' : 'FAILED TO SEND'}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    <div className="mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
                        <button className="btn btn-light btn-sm rounded-pill px-3 border x-small fw-bold" onClick={() => window.print()}>
                            <i className="bi bi-printer me-2"></i> Export Logs
                        </button>
                        <button className="btn btn-primary btn-sm rounded-pill px-4 fw-bold shadow-sm" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}